import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FontIconComponent } from '@finder/shared/components/font-icon/font-icon.component';
import { LinkIdDirective } from '@finder/shared/directives/link-id/link-id.directive';

@Component({
    selector: 'finder-hero-cta-action',
    templateUrl: './hero-cta-action.component.html',
    styleUrls: ['./hero-cta-action.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FontIconComponent,
        LinkIdDirective,
    ]
})
export class HeroCtaActionComponent {
    @Input() ctaData: any;
    @Input() ctaClass: string;
    @Output() ctaClick = new EventEmitter();

    constructor() { }

    anchorClick(event) {
        event.stopPropagation();
        event.preventDefault();

        this.ctaClick.emit('heroCtaAction.clicked');
    }
}
